import Tabs from "components/lib/Shared/Tabs";
import { useState, useEffect } from "react";
import CompanySummary from "./CompanySummary";
import GovernanceSummary from "./GovernanceSummary";
import StepButtons from "components/lib/Global/StepButtons";

const Summary = ({ goToNextParentTab, goToPrevParentTab, isViewMode }) => {
  const tabs = [
    {
      id: "companySummary",
      label: "Company Summary",
    },
    {
      id: "governanceSummary",
      label: "Governance Summary",
    },
  ];
  const [selectedTab, setSelectedTab] = useState(tabs[0]);
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const isFirstStep = selectedTabIndex === 0;
  const isLastStep = selectedTabIndex === tabs.length - 1;

  useEffect(() => {
    setSelectedTab(tabs[selectedTabIndex]);
  }, [selectedTabIndex]);

  const goToPrevStep = () => {
    if (isFirstStep) {
      goToPrevParentTab();
    } else {
      setSelectedTabIndex((prev) => prev - 1);
    }
  };

  const goToNextStep = () => {
    if (isLastStep) {
      goToNextParentTab();
    } else {
      setSelectedTabIndex((prev) => prev + 1);
    }
  };

  return (
    <div>
      <div>
        <Tabs
          tabs={tabs}
          setSelectedTabIndex={setSelectedTabIndex}
          selectedTabIndex={selectedTabIndex}
        />
      </div>
      <div>
        {selectedTab.id === "companySummary" && (
          <CompanySummary isViewMode={isViewMode} />
        )}
        {selectedTab.id === "governanceSummary" && (
          <GovernanceSummary isViewMode={isViewMode} />
        )}
      </div>
      <StepButtons
        isFirstStep={isFirstStep}
        goToPrevStep={goToPrevStep}
        goToNextStep={goToNextStep}
        prevBtnLabel={"Previous Step"}
        nextBtnLink={null}
        nextBtnLabel={"Confirm Details"}
        isLastStep={isLastStep}
      />
    </div>
  );
};

export default Summary;
